/* eslint-disable */
import React from 'react';
import {Link} from 'react-router-dom';
import imperialTobacco from '../../../assets/img/imperial_tobacco.png';
import johnPlayer from '../../../assets/img/john_player_ignite_col_logo.png';
import igniteLogo from '../../../assets/img/ignite_logo.png';
import './logos.css';
import {createObjectFromStack, currentStack} from '../../../data/stack';
import {tradeSiteDisabled} from '../../../utils/toggles';

const UKLogo = () => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-lg-offset-1 col-lg-22 col-md-offset-1 col-md-22">
        <div className="brands" style={ { textAlign: "left" } }>
          <Link to="/" title="Imperial Tobacco">
            <img src={imperialTobacco} alt="Imperial Tobacco"/>
          </Link>
          {
            tradeSiteDisabled() ?
                <Link to="/" title="Ignite">
                  <img src={igniteLogo} alt="Ignite"/>
                </Link>
                : null
          }
        </div>
        <div className="col-lg-4"/>
      </div>
    </div>
  </div>
);

const IrelandLogo = () => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-lg-offset-1 col-lg-22 col-md-offset-1 col-md-22">
        <div className="brands">
          <img alt="John Player Ignite Logo" className="john-player-logo" src={johnPlayer} title="John Player Ignite"/>
        </div>
        <div className="col-lg-4"/>
      </div>
    </div>
  </div>
);

export default () => createObjectFromStack(<UKLogo/>, <IrelandLogo/>)[currentStack]



// WEBPACK FOOTER //
// ./src/components/layout/empty/logos.jsx